import React from 'react';
import { useParams } from 'react-router-dom';
import { ErrorMessage } from '../features/status';
import { createCurriculum } from '../hooks/useCurriculum';
import { AgeCategory, BrandCode, CurriculumBrand } from '../features/curriculum';

type UrlParams = {
  crmBrandCode: BrandCode;
  crmAgeCategory: AgeCategory;
};

type CurriculumContextType = { brand: CurriculumBrand; ageCategory: AgeCategory };

const CurriculumContext = React.createContext<CurriculumContextType | null>(null);

export const CurriculumProvider = ({ children }: { children: React.ReactNode }) => {
  const { crmBrandCode, crmAgeCategory } = useParams<UrlParams>();

  if (!crmBrandCode || !crmAgeCategory) {
    return <>{children}</>;
  }

  const curriculum = createCurriculum(crmBrandCode, crmAgeCategory);

  if (!curriculum?.brand || !curriculum?.ageCategory) {
    return <ErrorMessage />;
  }

  return (
    <CurriculumContext.Provider value={{ brand: curriculum.brand, ageCategory: curriculum.ageCategory }}>
      {children}
    </CurriculumContext.Provider>
  );
};

export default CurriculumContext;
